import script from "./JobDetailPage.vue?vue&type=script&setup=true&lang=js"
export * from "./JobDetailPage.vue?vue&type=script&setup=true&lang=js"

import "./JobDetailPage.vue?vue&type=style&index=0&id=239a4ea2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239a4ea2"]])

export default __exports__